var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"codeBtn",attrs:{"size":"small","type":"primary","disabled":_vm.showGetCode},on:{"click":function($event){return _vm.getCode()}}},[_vm._v(_vm._s(_vm.codeText))])
}
var staticRenderFns = []

export { render, staticRenderFns }